namespace $.$$ {

	const $shm_hitalama_agent_map_chat_resized = Symbol( '$shm_hitalama_agent_map_chat_resized' )
	const $shm_hitalama_agent_map_chat_sized = Symbol( '$shm_hitalama_agent_map_chat_sized' )
	const $shm_hitalama_agent_map_chat_sessions_tools = Symbol( '$shm_hitalama_agent_map_chat_sessions_tools' )

	export class $shm_hitalama_agent_map_chat extends $.$shm_hitalama_agent_map_chat {

		map_id() {
			return this.$.$mol_state_arg.value( 'map' ) ?? ''
		}

		project_id() {
			return this.$.$mol_state_arg.value( 'project' ) ?? ''
		}

		project_chat() {
			return this.$.$mol_state_arg.value( 'section' ) === 'projects' && !!this.project_id()
		}

		override server_url( next?: string ) {
			if( next !== undefined ) return next
			return this.server_url_default()
		}

		server_url_default() {
			if( this.project_chat() ) {
			return $shm_hitalama_agent_endpoint.agent_url( 'opencode-dev', 'http://localhost:4096' )
			}
			return $shm_hitalama_agent_endpoint.agent_url( 'opencode', 'http://localhost:4096' )
		}

		agent_id() {
			if( !this.map() ) return ''
			const agents = $mol_wire_sync( $shm_hitalama_agent_api ).agents( this.server_url() )
			return agents.some( agent => agent.name === 'hitalama-map' ) ? 'hitalama-map' : ''
		}

		new_session_model() {
			const view = this as any as $shm_hitalama_agent_session
			return view.model_current()
		}

		map() {
			if( this.project_chat() ) return null
			const id = this.map_id()
			if( !id ) return null
			return $giper_baza_glob.Pawn( new $giper_baza_link( id ), $shm_hitalama_map )
		}

		agent_profile() {
			return this.$.$shm_hitalama_profile.current()
		}

		general_scope_key() {
			const profile = this.agent_profile()?.link().str || 'local'
			return `hitalama_agent_general:${ profile }:${ this.agent_config() }:${ this.server_url() }`
		}

		scope_session_ids( next?: readonly string[] ): readonly string[] {
			const map = this.map()
			if( map ) {
				if( next !== undefined ) map.store( this.map_session_ids_key(), [ ... next ] )
				return this.map_session_ids( map )
			}
			return this.$.$mol_state_local.value< readonly string[] >( `${ this.general_scope_key() }:sessions`, next ) ?? []
		}

		general_session_id( next?: string ) {
			const key = `${ this.general_scope_key() }:current`
			if( next !== undefined ) {
				if( next && !this.scope_session_ids().includes( next ) ) this.scope_session_ids( [ next, ... this.scope_session_ids() ] )
				return this.$.$mol_state_local.value( key, next ) ?? ''
			}
			return this.$.$mol_state_local.value< string >( key ) || this.scope_session_ids()[0] || ''
		}

		override prompt( next?: string ) {
			const map = this.map()
			const profile = map ? this.agent_profile() : null
			if( !map || !profile ) {
				if( this.project_chat() ) return super.prompt( next )
				return this.$.$mol_state_local.value< string >( `${ this.general_scope_key() }:draft:${ this.session_id() }`, next ) ?? ''
			}
			if( next !== undefined ) profile.agent_map_draft( map.link().str, next )
			return this.prompt_current()
		}

		@ $mol_mem
		prompt_current(): string {
			const map = this.map()
			const profile = map ? this.agent_profile() : null
			return map && profile ? profile.agent_map_draft( map.link().str ) : super.prompt()
		}

		project() {
			if( !this.project_chat() ) return null
			const id = this.project_id()
			if( !id ) return null
			return this.$.$shm_projects_data.record( id )
		}

		project_session_id( next?: string ) {
			const project = this.project()
			if( !project ) return ''
			return this.$.$shm_projects_data.session_current( project.id, next )
		}

		session_pages() {
			return this.thinking_visible()
				? [ this.Thinking_page(), this.Chat_page() ]
				: [ this.Chat_page() ]
		}

		override Chat_page() {
			return this.page_with_sessions( this.page_with_resizer( super.Chat_page() ) )
		}

		override Thinking_page() {
			return this.page_with_width( super.Thinking_page() )
		}

		override No_map_page() {
			return this.page_with_resizer( super.No_map_page() )
		}

		page_with_resizer< Page extends $mol_page >( page: Page ) {
			const state = page as any
			if( state[ $shm_hitalama_agent_map_chat_resized ] ) return page
			state[ $shm_hitalama_agent_map_chat_resized ] = true

			const sub = page.sub.bind( page )
			const style = page.style.bind( page )

			page.sub = () => [ ... sub(), this.Side_resizer() ]
			page.style = () => ({
				... style(),
				width: this.width_px(),
				flexBasis: this.width_px(),
				flexGrow: '0',
				flexShrink: '0',
				minWidth: '24rem',
				position: 'relative',
			})

			return page
		}

		page_with_width< Page extends $mol_page >( page: Page ) {
			const state = page as any
			if( state[ $shm_hitalama_agent_map_chat_sized ] ) return page
			state[ $shm_hitalama_agent_map_chat_sized ] = true

			const style = page.style.bind( page )
			page.style = () => ({
				... style(),
				width: this.thinking_width_px(),
				flexBasis: this.thinking_width_px(),
				flexGrow: '0',
				flexShrink: '0',
				minWidth: '24rem',
			})

			return page
		}

		page_with_sessions< Page extends $mol_page >( page: Page ) {
			const state = page as any
			if( state[ $shm_hitalama_agent_map_chat_sessions_tools ] ) return page
			state[ $shm_hitalama_agent_map_chat_sessions_tools ] = true

			const tools = page.tools.bind( page )
			page.tools = () => !this.project_chat() ? [ this.Map_sessions(), ... tools() ] : tools()

			return page
		}

		thinking_visible() {
			const view = this as any as $shm_hitalama_agent_session
			return !!view.thinking_message_id()
		}

		thinking_width_px() {
			return `${ this.thinking_width() }px`
		}

		panel_width_px() {
			const width = this.width() + ( this.thinking_visible() ? this.thinking_width() : 0 )
			return `${ width }px`
		}

		map_page() {
			const id = this.map_id()
			if( !id ) return null
			try {
				const app = this.$.$shm_hitalama_app.Root(0) as $.$$.$shm_hitalama_app
				return app.Maps().Book( id ).Map_page() as $shm_hitalama_map_page
			} catch( error ) {
				return null
			}
		}

		@ $mol_mem
		events() {
			const url = this.server_url()
			this.$.$shm_hitalama_settings.agent_token()
			return this.$.$shm_hitalama_agent_api_events.make({
				url: ()=> url,
				notify: $mol_const( ( event: $shm_hitalama_agent_api_event )=> this.event_handle( event ) ),
			})
		}

		events_native() {
			if( !this.session_id() && !this.project_session_id() ) return null
			return this.events().native()
		}

		@ $mol_action
		event_handle( raw: $shm_hitalama_agent_api_event ) {
			const event = raw.payload ?? raw
			const type = event.type
			const props = event.properties ?? {}
			const session_id = props.sessionID
			const view = this as any as $shm_hitalama_agent_session

			if( type === 'server.connected' ) {
				if( this.session_id() ) view.messages_ensure( this.session_id() )
				view.questions_ensure()
				return
			}

			if( type === 'session.created' || type === 'session.updated' ) {
			$shm_hitalama_agent_map_sessions.session_upsert_global(
					this.server_url(),
				$shm_hitalama_agent_map_sessions.session_from_event( props ),
				)
			}

			if( !session_id || session_id !== this.session_id() ) return

			if( type === 'message.updated' ) {
				view.message_info_upsert( session_id, props.info )
				return
			}

			if( type === 'message.removed' ) {
				view.message_remove( session_id, props.messageID )
				return
			}

			if( type === 'message.part.updated' ) {
				view.message_part_upsert( session_id, props.part )
				return
			}

			if( type === 'message.part.removed' ) {
				view.message_part_remove( session_id, props.messageID, props.partID )
				return
			}

			if( type === 'message.part.delta' ) {
				view.message_part_delta( session_id, props.messageID, props.partID, props.field, props.delta )
				return
			}

			if( type === 'question.asked' ) {
				view.question_upsert( props )
				return
			}

			if( type === 'question.replied' || type === 'question.rejected' ) {
				view.question_remove( props.requestID )
				return
			}

			if( type === 'session.idle' || type === 'session.error' || type === 'session.status' ) {
				view.session_event_status( session_id, type, props )
				view.load_messages_later( session_id, 50, true )
			$shm_hitalama_agent_map_sessions.sessions_refresh_global( this.server_url() )
			}
		}

		override session_id( next?: string ) {
			if( !this.map() && !this.project_chat() ) return this.general_session_id( next )
			return this.map_session_current( next )
		}

		@ $mol_mem
		map_session_current( next?: string ) {
			const map = this.map()
			if( next !== undefined ) {
				if( map ) {
					this.map_session_id_local( map, next )
					if( next ) this.map_session_attach( map, next )
				} else {
					this.project_session_id( next )
				}
				return next
			}

			const project_session = this.project_session_id()
			if( project_session ) return project_session
			if( !map ) return ''

			const stored = this.map_session_id_local( map )
			const ids = this.map_session_ids( map )
			if( stored && ids.includes( stored ) ) return stored
			if( ids[0] ) {
				this.map_session_id_local( map, ids[0] )
				return ids[0]
			}

			const view = this as any as $shm_hitalama_agent_session
			const session = $mol_wire_sync( $shm_hitalama_agent_api ).create_session(
				this.server_url(),
				null,
				view.model_current(),
			) as $shm_hitalama_agent_api_session
			$shm_hitalama_agent_map_sessions.session_upsert_global( this.server_url(), session )
			this.map_session_attach( map, session.id )
			this.map_session_id_local( map, session.id )
			view.messages_data( session.id, [] )
			view.messages_loaded( session.id, true )
			return session.id
		}

		session_context_sync( session_id: string ) {
			const map = this.map()
			if( !map ) return

			const app = this.$.$shm_hitalama_app.Root(0) as $.$$.$shm_hitalama_app
			const context = {
				session_id,
				client_id: app.mcp_client().client_id(),
				map_id: map.link().str,
				map_title: map.title(),
				url: this.$.$mol_dom_context.document?.location.href ?? '',
			}

			if( this.$.$shm_hitalama_settings.agent_backend() !== 'dsh' ) {
				$mol_wire_sync( $shm_hitalama_agent_api ).mcp_session_context(
						$shm_hitalama_agent_endpoint.mcp_url(),
					context,
				)
			}
		}

		map_context_prompt( session_id: string, client_id: string, map_id: string, map_title: string ) {
			return [
				'Контекст Hitalama карты:',
				`session_id: ${ session_id }`,
				`client_id: ${ client_id }`,
				`map_id: ${ map_id }`,
				`map_title: ${ map_title }`,
				'Во все hitalama tools передавай session_id, client_id и map_id из этого контекста.',
			].join( '\n' )
		}

		outgoing_prompt( session_id: string, text: string ) {
			if( this.$.$mol_state_arg.value( 'section' ) === 'applications' ) {
				const view = this as any as $shm_hitalama_agent_session
				return view.system_prompt_pack( this.$.$shm_hitalama_components_agent.prompt( this.$.$shm_hitalama_app.Root(0) as $.$$.$shm_hitalama_app ), text )
			}
			const map = this.map()
			if( !map ) return (this as any as $shm_hitalama_agent_session).system_prompt_pack( this.$.$shm_hitalama_skills_agent.prompt(), text )
			const app = this.$.$shm_hitalama_app.Root(0) as $.$$.$shm_hitalama_app
			const system = this.map_context_prompt(
				session_id,
				app.mcp_client().client_id(),
				map.link().str,
				map.title(),
			)
			const view = this as any as $shm_hitalama_agent_session
			return view.system_prompt_pack( this.$.$shm_hitalama_skills_agent.prompt() + '\n' + system, text )
		}

		map_session_id_local( map: $shm_hitalama_map, next?: string ) {
			return this.$.$mol_state_local.value< string >(
				`hitalama_opencode_map_session_id:${ this.$.$shm_hitalama_settings.agent_config_current() }:${ map.link().str }`,
				next,
			) ?? ''
		}

		map_session_ids( map: $shm_hitalama_map ) {
			const value = map.store( this.map_session_ids_key() )
			if( Array.isArray( value ) ) return value.filter( item => typeof item === 'string' && item )
			if( typeof value === 'string' ) {
				try {
					const parsed = JSON.parse( value )
					if( Array.isArray( parsed ) ) return parsed.filter( item => typeof item === 'string' && item )
				} catch( error ) {
					return []
				}
			}
			return []
		}

		map_session_attach( map: $shm_hitalama_map, session_id: string ) {
			const ids = this.map_session_ids( map )
			if( ids.includes( session_id ) ) return ids
			const next = [ session_id, ... ids ]
			map.store( this.map_session_ids_key(), next )
			return next
		}

		map_session_ids_key() {
			const config = this.$.$shm_hitalama_settings.agent_config_current()
			return config === 'default' ? 'opencode_session_ids' : `opencode_session_ids:${ config }`
		}

		no_map_text() {
			return 'Откройте карту или выберите сессию проекта'
		}

	}

}
